import React from "react";

// components
import Inclusion from "../Home/Inclusion/Inclusion";

// css
import * as styles from "./BookPack.module.css";

const WhatsIncludedModal = props => {
  return (
    <>
      {props.windowSize && props.windowSize.width <= 768 ? (
        <div>
          <div
            className="offcanvas offcanvas-bottom"
            data-bs-scroll="false"
            tabIndex="-1"
            id={props.id}
            aria-labelledby="offcanvasBottomLabel"
            style={{ height: "100%" }}
          >
            <div
              className={`offcanvas-header ${styles.bookpack_whatsModal_header}`}
            >
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className={styles.bookpack_whatsModal_bdy}>
              <Inclusion modal={true} twinRead={props.twinRead} />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div
            className="offcanvas offcanvas-end"
            data-bs-scroll="false"
            tabIndex="-1"
            id={props.id}
            aria-labelledby="offcanvasRightLabel"
          >
            <div
              className={`offcanvas-header ${styles.bookpack_whatsModal_header}`}
            >
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className={styles.bookpack_whatsModal_bdy}>
              <Inclusion modal={true} twinRead={props.twinRead} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsIncludedModal;
